export const MARITAL_STATUS = [
  {
    label: 'Married',
    value: 'Married',
  },
  {
    label: 'Single',
    value: 'Single',
  },
  {
    label: 'Separated',
    value: 'Separated',
  },
  {
    label: 'Divorced',
    value: 'Divorced',
  },
  {
    label: 'Widowed',
    value: 'Widowed',
  },
  {
    label: 'Domestic Partner',
    value: 'Domestic Partner',
  },
];
